class blogPagination extends HTMLElement {
    constructor() {
        super();

        this.mainBlog = document.querySelector("[js-main-blog]");
        this.scrollToElement = this.mainBlog.querySelector("[data-scroll-to]");
        this.sectionId = this.mainBlog.dataset.sectionId;

        this.init();
    };

    init() {
        const paginationItems = this.querySelectorAll("[js-pagination-item]");

        paginationItems.forEach( item => {
          item.addEventListener('click', (e) => {
            e.preventDefault();
            const url = e.currentTarget.getAttribute("href");

            document.dispatchEvent(new CustomEvent("scroll:init"));
            document.dispatchEvent(new CustomEvent("loading:init", {
                detail: {
                    loading: true
                }
            }));
            this.initAjaxBlog(url, e.currentTarget);
          })
        })
    }

    initAjaxBlog(url) {
        document.dispatchEvent(new CustomEvent("updateHistoryState", {
            detail: {
                url
            }
        }));
        this.renderAjaxBlog(url);
    };

    renderAjaxBlog(paginationUrl) {
        const url = `${paginationUrl}&section_id=${this.sectionId}`;

        fetch(url).then(function(response) {
            return response.text();
        }).then((html) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            this.mainBlog.innerHTML = doc.querySelector("[js-main-blog]").innerHTML;
            document.dispatchEvent(new CustomEvent("loading:init", {
                detail: {
                    loading: false
                }
            }));
        });
    }
}
  
customElements.define('blog-pagination', blogPagination);
  